import type { OptionValue } from '@tempmee/core';

export const TIME_PER_PATIENT_OPTIONS: OptionValue<string>[] = [
  '30 min',
  '45 min',
  '1 hr',
  '1.5 hr',
  '2+ hr',
].map((v) => ({ label: v, value: v }));

export const YES_NO_OPTIONS: OptionValue<string>[] = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

export const COST_UNIT_OPTIONS: OptionValue<string>[] = [
  { label: 'Hour', value: 'hr' },
  { label: 'Day', value: 'day' },
];

// Collapsed-view allowlist for the Office Software section. Figma pins these
// six as the "popular" row; the full catalog (including these) comes from
// `state.user.officeEducation.softwares`. If the BE stops returning any of
// these, the collapsed row just renders fewer pills.
// Names mirror the BE `softwares` catalog exactly (case-sensitive — the
// collapsed filter uses `Set.has`, so "EagleSoft" ≠ "Eaglesoft").
export const POPULAR_SOFTWARES = [
  'Dentrix',
  'EagleSoft',
  'Open Dental',
  'Dexis',
  'Denticon',
  'SOFTDENT',
];

// Parking type fallback — values mirror `ParkingTypeEnum` (src/models/
// ParkingInformation.ts), which is what legacy GeneralOfficeInformation
// + ParkingInfoPopup render from `allMetadata.parkingTypes`.
export const PARKING_TYPE_FALLBACK: OptionValue<string>[] = [
  { label: 'On-site parking', value: 'On-site parking' },
  { label: 'Street parking', value: 'Street parking' },
  { label: 'Parking garage', value: 'Parking garage' },
  { label: 'Off-site parking lot', value: 'Off-site parking lot' },
  { label: 'Other', value: 'Other' },
];

export const PROFESSIONAL_RADIUS_MILES = 25;
